// extracted by mini-css-extract-plugin
export var selectedChip = "search-filter-chip-module--selectedChip--23d37";
export var title = "search-filter-chip-module--title--8e4b6";
export var unselectedChip = "search-filter-chip-module--unselectedChip--48d6d";